import useJwt from '@/auth/jwt/useJwt'

export const logoutToAccountSelection = (vm, accounts) => {
  const prefix = vm.$route.params.prefix || localStorage.getItem('prefix')
  const currentSite = localStorage.getItem('currentSite')
  localStorage.clear()
  localStorage.setItem('loggedAccountsInfo', JSON.stringify(accounts))
  localStorage.setItem('prefix', prefix)
  localStorage.setItem('language', vm.$i18n.locale)
  if (currentSite) localStorage.setItem('currentSite', currentSite)
  const domain = window.location.href.includes('indsiders.com') ? 'indsiders.com' : null
  vm.$cookies.remove('userInfo', null, domain)
  vm.$cookies.remove('company', null, domain)
  window.location.href = `/${prefix}/change-account`
}

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData')
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userData) return '/'
  return { name: 'login' }
}
